module.exports = __webpack_public_path__ + "img/goblin.dc6dfb57.png";